import React from 'react';
import { motion } from 'framer-motion';
export function Section6() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="bg-[#0F4226] text-white py-16" data-id="element-133">
      <div className="max-w-3xl mx-auto px-6" data-id="element-134">
        <h2 className="font-sans font-bold text-4xl mb-8" data-id="element-135">
          6. Introducing FLO
        </h2>

        <div className="mb-12 flex justify-center" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/4sDKULEj9c65Na4mpWCQ87/AI-Generated-Image-1_(3).png" alt="FLO makes your pet invisible to fleas and ticks — two happy dogs running in a field with protective shield" className="w-full rounded shadow-2xl" data-id="element-137" />
        </div>

        <div className="font-sans text-lg leading-relaxed space-y-6 text-white/90" data-id="element-138">
          <p className="text-xl" data-id="element-139">
            By this point you believe plant chemistry works. Now you need to
            understand why this specific product succeeds where everything else
            failed.
          </p>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded my-8" data-id="element-140">
            <h3 className="font-sans font-bold text-2xl mb-4 text-white" data-id="element-141">
              The Delivery Breakthrough
            </h3>
            <p data-id="element-142">
              The reason the ancient methods worked (continuous ambient exposure
              to plant VOCs) is exactly the reason sprays and herbal collars
              don't — they can't maintain continuous emission at effective
              concentrations over time. FLO's pendant is engineered to do
              precisely that.
            </p>
          </div>

          <h3 className="font-sans font-bold text-2xl mt-8 mb-4 text-white" data-id="element-143">
            How the Pendant Works
          </h3>
          <p data-id="element-144">
            Once clipped to the collar, the pendant continuously emits a
            specific combination of plant-derived VOCs at consistent
            concentrations — 24 hours a day, passively, without any action
            required from you.
          </p>

          <div className="grid md:grid-cols-2 gap-6 my-8" data-id="element-145">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded" data-id="element-146">
              <h4 className="font-sans font-bold text-xl mb-2 text-white" data-id="element-147">
                12 Months Duration
              </h4>
              <p data-id="element-148">
                Not 12 days. Not 12 weeks. 12 months. Clip it on in March. It's
                still working in February.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded" data-id="element-149">
              <h4 className="font-sans font-bold text-xl mb-2 text-white" data-id="element-150">
                Waterproof
              </h4>
              <p data-id="element-151">
                Works through rain, swimming, bathing — the mechanisms that
                cause spray failure don't apply.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded" data-id="element-152">
              <h4 className="font-sans font-bold text-xl mb-2 text-white" data-id="element-153">
                No Residue
              </h4>
              <p data-id="element-154">
                No application process, no timing windows, no keeping children
                away from a treated pet.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded" data-id="element-155">
              <h4 className="font-sans font-bold text-xl mb-2 text-white" data-id="element-156">
                Passive Protection
              </h4>
              <p data-id="element-157">The protection is airborne and passive, not topical.</p>
            </div>
          </div>

          <div className="bg-[#4DC61A] text-white p-8 rounded my-8" data-id="element-158">
            <h3 className="font-sans font-bold text-2xl mb-4" data-id="element-159">
              The Seresto Comparison
            </h3>
            <p className="text-lg" data-id="element-160">
              Seresto's entire appeal was passive, long-duration, wearable
              protection — and the market proved overwhelmingly that pet owners
              want exactly that format.{' '}
              <strong data-id="element-161">
                FLO delivers the same passive convenience Seresto offered,
                through plant chemistry instead of synthetic pesticides.
              </strong>{' '}
              The convenience you wanted. Without the danger you discovered.
            </p>
          </div>

          <div className="text-center my-12" data-id="element-162">
            <p className="text-3xl font-sans font-bold mb-4 text-white" data-id="element-163">
              Clip it on. Forget about it. Let it work.
            </p>
            <p className="text-2xl mb-2" data-id="element-164">$39.99 for 12 months of protection</p>
            <p className="text-xl opacity-90" data-id="element-165">Less than $3.34 per month</p>
            <p className="text-lg mt-4 mb-8" data-id="element-166">
              Available for dogs and cats of all sizes
            </p>
            <a href="https://zenessa.shop/products/pet-flea-collar" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#4DC61A] hover:bg-[#43b016] text-white font-sans font-bold text-xl px-10 py-4 rounded-[100px] shadow-lg transition-all duration-200" data-id="element-167">
              Try FLO Risk-Free
            </a>
          </div>
        </div>
      </div>
    </motion.section>;
}